import { z } from "zod";

export type ConnectionState = {
  token: string | null;
  is_anonymous: boolean;
  user?: UserData;
};

export const ConnectionQuery = z.object({
  token: z.string().optional(),
});

export type UserData = {
  id: string;
  avatarUrl: string;
  username: string;
};

export type ConnectionQuery = z.infer<typeof ConnectionQuery>;

export enum BuiltinEvent {
  GET_CONNECTED_CLIENTS = "BUILTIN:GET_CONNECTED_CLIENTS",
  REQUEST_ERROR = "BUILTIN:REQUEST_ERROR",
  CREATE_DB_RECORD = "RECORD:CREATE",
  UPDATE_DB_RECORD = "RECORD:UPDATE",
  GET_DB_RECORDS = "RECORD:LIST",
  DELETE_DB_RECORD = "RECORD:DELETE",
  UPDATE_PRESENCE = "PRESENCE:UPDATE",
  GET_PRESENCE = "PRESENCE:GET",
  UPDATE_ROOM_STATE = "ROOM_STATE:UPDATE",
  GET_ROOM_STATE = "ROOM_STATE:GET",
  PRESENCE_REQUEST_UPDATE = "PRESENCE:REQUEST_UPDATE",
}

export enum FromServer {
  Reset = "reset",
  Connected = "connected",
  Disconnected = "disconnected",
  PresenceUpdated = "presence_updated",
  RoomStateUpdated = "room_state_updated",
  PresenceUpdateRequested = "presence_update_requested",
}
